import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiRouterService } from '../http/api.router';
import { BaseHttpService } from '../http/base.http.service';

@Injectable({
  providedIn: 'root'
})
export class ActivePassesHttpService extends BaseHttpService {

  private baseURL = `active-passes`;

  constructor(
    @Inject(HttpClient) httpClient: HttpClient,
    private routerService: ApiRouterService,
  ) {
    super(httpClient);
  }

  public getByUser(userId: number) {
    const url = this.routerService.mount(`${this.baseURL}/user/${userId}`);
    return this.read(url);
  }

  public getByTemporalPass(temporalPassId: number) {
    const url = this.routerService.mount(`${this.baseURL}/temporal-pass/${temporalPassId}`);
    return this.read(url);
  }

  public createActivePass(body: any) {
    const url = this.routerService.mount(this.baseURL);
    return this.create(body, url);
  }

  public updateActivePass(id: number, body: any) {
    const url = this.routerService.mount(`${this.baseURL}/${id}`);
    return this.update(body, url);
  }

  public deleteActivePass(id: number) {
    const url = this.routerService.mount(`${this.baseURL}/${id}`);
    return this.delete(url);
  }
}
